export const areSameDay = (d1, d2) => (
  d1.getFullYear() === d2.getFullYear() &&
  d1.getMonth() === d2.getMonth() &&
  d1.getDate() === d2.getDate()
);

/**
 * Convert ISO string to UTC time for the day, ignoring the
 * time.
 * @param {string} isoTime time represented as Iso string.
 * @returns {number} UTC time in ms.
 * (i.e. no of ms since jan1, 1970,January 1, 1970, 00:00:00 UTC.)
 */
export const ConvertDateToUTCDay = (isoTime) => {
  const date = new Date(isoTime);

  return Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate()
  );
};

/**
 * Check if the provided PST time is expired. (Used mainly in coupon
 * scenarios where coupon expiry time is always in PST without timezone info).
 * @param {string} expiryDatePST time value in PST without timezone
 * @returns {bool} If the time is expired per local time.
 */
export const HasDateExpiredInPST = (expiryDatePST) => {
  const localNow = new Date();
  const utcNow = localNow.getTime();
  // Expiry date is in PST
  const localExpiry = new Date(`${expiryDatePST}-08:00`);
  const utcExpiry = localExpiry.getTime();

  return utcNow > utcExpiry;
};

export const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

export const getDatePickerStrings = i18n => ({
  months: [
    i18n.getString(_TL_('January')),
    i18n.getString(_TL_('February')),
    i18n.getString(_TL_('March')),
    i18n.getString(_TL_('April')),
    i18n.getString(_TL_('May')),
    i18n.getString(_TL_('June')),
    i18n.getString(_TL_('July')),
    i18n.getString(_TL_('August')),
    i18n.getString(_TL_('September')),
    i18n.getString(_TL_('October')),
    i18n.getString(_TL_('November')),
    i18n.getString(_TL_('December')),
  ],

  shortMonths: [
    i18n.getString(_TL_('Jan')),
    i18n.getString(_TL_('Feb')),
    i18n.getString(_TL_('Mar')),
    i18n.getString(_TL_('Apr')),
    i18n.getString(_TL_('May')),
    i18n.getString(_TL_('Jun')),
    i18n.getString(_TL_('Jul')),
    i18n.getString(_TL_('Aug')),
    i18n.getString(_TL_('Sep')),
    i18n.getString(_TL_('Oct')),
    i18n.getString(_TL_('Nov')),
    i18n.getString(_TL_('Dec')),
  ],

  days: [
    i18n.getString(_TL_('Sunday')),
    i18n.getString(_TL_('Monday')),
    i18n.getString(_TL_('Tuesday')),
    i18n.getString(_TL_('Wednesday')),
    i18n.getString(_TL_('Thursday')),
    i18n.getString(_TL_('Friday')),
    i18n.getString(_TL_('Saturday')),
  ],

  shortDays: [
    i18n.getString(_TL_('S')),
    i18n.getString(_TL_('M')),
    i18n.getString(_TL_('T')),
    i18n.getString(_TL_('W')),
    i18n.getString(_TL_('T')),
    i18n.getString(_TL_('F')),
    i18n.getString(_TL_('S')),
  ],

  goToToday: i18n.getString(_TL_('Go to today')),
  prevMonthAriaLabel: i18n.getString(_TL_('Go to previous month')),
  nextMonthAriaLabel: i18n.getString(_TL_('Go to next month')),
  prevYearAriaLabel: i18n.getString(_TL_('Go to previous year')),
  nextYearAriaLabel: i18n.getString(_TL_('Go to next year')),
  closeButtonAriaLabel: i18n.getString(_TL_('Close date picker')),

  isRequiredErrorMessage: i18n.getString(_TL_('Start date is required.')),
  invalidInputErrorMessage: i18n.getString(_TL_('Invalid date format.')),
});
